import { render, staticRenderFns } from "./CoolInput.vue?vue&type=template&id=b01630e4&scoped=true&"
import script from "./CoolInput.vue?vue&type=script&lang=ts&"
export * from "./CoolInput.vue?vue&type=script&lang=ts&"
import style0 from "./CoolInput.vue?vue&type=style&index=0&id=b01630e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01630e4",
  null
  
)

export default component.exports